export default "__VITE_ASSET__DZZ5rvNq__"